<template>
	<div>
      <form @submit.prevent="createProject">
      <div class="row mb-2">
        <div class="col-md-6">
          <strong>Title</strong>
          <input type="text" class="form-control" v-model="project.title" required>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <strong>Email</strong>
            <input type="text" class="form-control" v-model="project.email">
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">
          <div class="form-group">
            <strong>Restriction</strong>
            <input type="text" class="form-control" v-model="project.restriction">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <strong>Permission</strong>
            <input type="text" class="form-control" v-model="project.permission">
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">
          <div class="form-group">
            <strong>Date Penetration Tested </strong>
            <input type="text" class="form-control" v-model="project.date_tested">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <strong>URL </strong>
            <input type="text" class="form-control" v-model="project.url">
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">
          <div class="form-group">
            <strong>Test Type</strong>
            <input type="text" class="form-control" v-model="project.test_type" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <strong>Scanner Setting</strong>
            <select v-model="project.scanner" class="form-select">
              <option value="form">Forms</option>
              <option value="api">API</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <div class="form-group">
            <strong>Scanner availability</strong>
            <select v-model="project.scanner_status" class="form-select">
                <option value="0">Disabled</option>
                <option value="1">Enabled</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <strong>Scanner token</strong>
            <input type="text" class="form-control" v-model="project.scanner_token">
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6 col">
          <div class="form-group">
            <strong>Version</strong>
            <input type="text" class="form-control" v-model="project.version">
          </div>
        </div>
        <div class="col-md-6 col">
          <div class="form-group">
            <strong>Retest Date</strong>
            <input type="text" class="form-control" v-model="project.retest_date">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col">
          <div class="form-group">
            <strong>Test Completed Date</strong>
            <input type="date"
              class="form-control"
              v-model="project.test_completed"
              :required="project.status == 2 ? true : false"
            />
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-12 col">
          <div class="form-group">
            <strong>Description</strong>
              <vue-editor v-model="project.description" :editorToolbar="this.$customToolbar"></vue-editor>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="form-group">
            <strong>Checklist URL</strong>
            <input type="text" class="form-control" v-model="project.checklist_url">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <strong>Status</strong>
            <select class="form-select" v-model="project.status">
              <option value="1">In Progress</option>
              <option value="4">Cancelled</option>
              <option value="5">Not Started</option>
              <option value="2">Completed</option>
              <option value="3">Archive</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="form-group">
            <strong>Payment Status</strong>
            <select class="form-select" v-model="project.payment_status">
              <option value="1">Unpaid</option>
              <option value="2">Paid</option>
            </select>
          </div>
        </div>
      </div>
      <h3 class="mt-3">PDF SETTINGS</h3>
      <div class="card bg-light">
        <div class="card-body">
          <p><i class="fa fa-robot"></i> Generate executive summary via gemini AI</p>
          <div class="form-group">
            <input type="text" name="commands" class="form-control" v-model="ai.prompt" />
            <div class="fw-bold mt-2">
              Exclude resolved?
              <span>
                <input type="radio" name="excludeResolved" v-model="ai.excludeResolved" value="resolved"> YES
              </span>
              <span>
                <input type="radio" name="excludeResolved" v-model="ai.excludeResolved" value="noresolved"> NO
              </span>
            </div>
          </div>
          <button type="button" class="btn btn-primary btn-sm mt-2" v-on:click="generateAI">Generate</button>
        </div>
      </div>
      <small>Note: To use default leave this empty</small>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <strong>Executive Summary <span class="text-danger"><small>(for custom summary in PDF)</small></span></strong>
              <textarea v-model="project.executive_summary" rows="5" class="form-control"></textarea>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="form-group">
            <strong>Date <span class="text-danger"><small>(for custom date in PDF)</small></span></strong>
              <input type="text" v-model="project.pdf_date" class="form-control">
          </div>
        </div>
      </div>
      <div class="text-start mt-3">
        <button type="submit" class="btn btn-outline-info rounded-pill">
          {{ titleF }} test
        </button>
      </div>
    </form>
  </div>
</template>
<script>
  import { VueEditor } from "vue2-editor";

  export default {
	name: "project_form",
    components: {
      VueEditor
    },
    props: {
      project_id: Number,
      title: String
    },
    data () {
      return {
        titleF: 'Create',
        ai: {
          prompt: '',
          excludeResolved: "noresolved"
        },
        project: {
          title: '',
          url: '',
          email: '',
          restriction: '',
          permission: '',
          description: '',
          executive_summary: '',
          scanner_status: 0,
          status: 1,
          scanner_token:  this.rndStr(32),
          checklist_url: '',
          test_completed: '',
          payment_status: 1,
        }
      }
    },
    mounted() {
      this.init();
      this.titleF = this.title;
    },
    methods: {
      rndStr(len) {
        let text = " "
        let chars = "abcdefghijklmnopqrstuvwxyz"

        for( let i=0; i < len; i++ ) {
          text += chars.charAt(Math.floor(Math.random() * chars.length))
        }

        return text
      },

      generateAI() {
        this.$axios.post(this.$server + 'admin/ai', {
              prompt: this.ai.prompt,
              exclude_resolved: this.ai.excludeResolved,
              project_id: this.project_id.toString()
            }
          )
          .then(res => {
            var r = res.data;
            if (r.success) {
              this.project.executive_summary = r.result;
            }
          });
      },

      createProject () {

        const me = this;
        this.project.scanner_status = parseInt(this.project.scanner_status);
        this.project.payment_status = parseInt(this.project.payment_status);
        this.project.status = parseInt(this.project.status);

        if (this.project_id != 0) {
          if (this.project.executive_summary == "") {
            this.project.executive_summary = " ";
          }

          if (this.project.pdf_date == "") {
            this.project.pdf_date = " ";
          }

          if (this.project.title == "") {
            this.project.title = " ";
          }

          if (this.project.url == "") {
            this.project.url = " ";
          }

          if (this.project.email == "") {
            this.project.email = " ";
          }

          if (this.project.restriction == "") {
            this.project.restriction = " ";
          }

          if (this.project.permission == "") {
            this.project.permission = " ";
          }

          if (this.project.description == "") {
            this.project.description = " ";
          }

          if (this.project.checklist_url == "") {
            this.project.checklist_url = " ";
          }

          if (this.project.retest_date == "") {
            this.project.retest_date = " ";
          }

          if (this.project.date_tested == " ") {
            this.project.date_tested = " ";
          }

          if (this.project.version == "") {
            this.project.version = " ";
          }

          if (this.project.test_type == " ") {
            return alert("Test type should not be empty");
          }

          this.$axios.put(this.$server + 'organisation/'+ this.$route.params.org_id +'/project/' + me.project_id, this.project)
            .then(res => {
              var r = res.data;
              if (r.success) {
                this.$swal({
                    title: r.message
                });
              }
            });
        } else {
          this.$axios.post(this.$server + 'organisation/'+ this.$route.params.org_id + '/project', this.project)
            .then(res => {
              var r = res.data;
              if (r.success) {
                this.$swal({
                    title: r.message
                });
              }
            });

        }
        this.$emit('callback', true);

        // partial fixed for not refreshing sidebar
        if (document.getElementById("refreshSidebar") != null) {
          document.getElementById("refreshSidebar").click(); // click the sidebar hidden refresh button
        }

      },

      init() {
        if (this.project_id != 0) {
          const me = this;
          this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id  + '/project/' + me.project_id)
            .then(res => {
              var r = res.data;
              if (r.success) {
                  me.project = r.data[0];
                  if (r.ai != null) {
                    me.ai.prompt = r.ai.value;
                  }
              }
            });
        }
      }
    }
  }

</script>